import { createSelector } from 'reselect';
 
const selectChannel = (state: any) => state.channel;
 
export const selectChannelCurrentItem = createSelector([selectChannel], (channel) => channel.current);
 
export const selectChannelListItems = createSelector([selectChannel], (channel) => channel.list);
 
 
export const selectChannelItemById = (itemId: any) =>
    createSelector(selectChannelListItems, (list) => list.result.items.find((item: any) => item._id === itemId));
 
export const selectChannelQueryItems = createSelector([selectChannel], (channel) => channel.query);

export const selectChannelCreatedItem = createSelector([selectChannel], (channel) => channel.create);
 
export const selectChannelUpdatedItem = createSelector([selectChannel], (channel) => channel.update);
 
export const selectChannelReadItem = createSelector([selectChannel], (channel) => channel.read);
 
export const selectChannelDeletedItem = createSelector([selectChannel], (channel) => channel.delete);
 
export const selectChannelSearchedItems = createSelector([selectChannel], (channel) => channel.search);
 
export const selectChannelItemsCount = createSelector([selectChannel], (channel) => channel.count);
 
export const selectChannelItemsFilter = createSelector([selectChannel], (channel) => channel.filter);